const CloverPaymentIssueState = Object.freeze({
    CHECKED: 'CHECKED',
    IN_PROGRESS: 'IN_PROGRESS',
    REQUIRED: 'REQUIRED',
});

module.exports = CloverPaymentIssueState;
